import { getAuthAgencyId } from "../../components/common/CommonFunctions";
import {
  AGENCY_DETAILS_URL,
  GET_SINGLE_USER,
  USER_LICENSEPLAN,
} from "../../constants/ApiPaths";
import { TTID } from "../../constants/LocalStorageVariables";
import { authCustomerHeader, authHeader } from "../../functions/CoreFunctions";
import {
  AGENCY_DELETE,
  AGENCY_DETAILS_ERROR,
  AGENCY_DETAILS_LOADING,
  AGENCY_DETAILS_SUCCESS,
  AUTH_USER_DETAILS_SUCCESS,
  CHOOSE_PLAN_ERROR,
  CHOOSE_PLAN_LOADING,
  CHOOSE_PLAN_SUCCESS,
  LOGGED_USER_DETAILS_ERROR,
  LOGGED_USER_DETAILS_LOADING,
} from "./ActionTypes";
import API from "./API";

export function getLoggedUserDetails(userId) {
  return async (dispatch) => {
    dispatch({
      type: LOGGED_USER_DETAILS_LOADING,
    });
    const options = {
      method: "GET",
      url: GET_SINGLE_USER,
      headers: authCustomerHeader(),
      params: { userId },
    };
    API(options)
      .then((response) => {
        const { status, data } = response.data;
        if (status === "Success") {
          dispatch({
            type: AUTH_USER_DETAILS_SUCCESS,
            payload: data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          dispatch({
            type: LOGGED_USER_DETAILS_ERROR,
            payload: data.message,
          });
        }
      });
  };
}
//Loged User Details
export function AgencygetLoggedUserDetails(userId) {
  return async (dispatch) => {
    dispatch({
      type: LOGGED_USER_DETAILS_LOADING,
    });
    const options = {
      method: "GET",
      url: GET_SINGLE_USER,
      headers: authHeader(),
      params: { userId },
    };
    API(options)
      .then((response) => {
        const { status, data } = response.data;
        if (status === "Success") {
          dispatch({
            type: AUTH_USER_DETAILS_SUCCESS,
            payload: data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          dispatch({
            type: LOGGED_USER_DETAILS_ERROR,
            payload: data.message,
          });
        }
      });
  };
}

//agency details
export function getLoggedAgencyDetails(agencyId) {
  return async (dispatch) => {
    dispatch({
      type: AGENCY_DETAILS_LOADING,
    });
    const options = {
      method: "GET",
      url: AGENCY_DETAILS_URL,
      headers: authHeader(),
      params: { agencyId },
    };
    API(options)
      .then((response) => {
        const { status, data } = response.data;
        if (status === "Success") {
          localStorage.setItem(TTID, data.ttid);
          dispatch({
            type: AGENCY_DETAILS_SUCCESS,
            payload: data,
          });
          dispatch({
            type: AGENCY_DELETE,
            payload: data.isdeleted,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          dispatch({
            type: AGENCY_DETAILS_ERROR,
            payload: data.message,
          });
        }
      });
  };
}

//End user form details
export function getChoosePlan(agencyId) {
  return async (dispatch) => {
    dispatch({
      type: CHOOSE_PLAN_LOADING,
    });
    const config = {
      method: "GET",
      url: USER_LICENSEPLAN,
      headers: authCustomerHeader(),
      params: {
        agencyId: getAuthAgencyId(),
      },
    };
    API(config)
      .then((response) => {
        const { status, data } = response.data;
        if (status === "Success") {
          dispatch({
            type: CHOOSE_PLAN_SUCCESS,
            payload: data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          dispatch({
            type: CHOOSE_PLAN_ERROR,
            payload: data.message,
          });
        }
      });
  };
}
